
<template>
  <div v-loading="loading" class="content-wrapper-with-tabs min-h-full">
    <template v-if="!loading">
      <template v-if="!emptyData">
        <div v-if="Object.keys(tabComps).length>1" class="mb-4 flex justify-center">
          <el-button-group>
            <el-button 
              v-for="(comp, idx) in tabComps" 
              :key="idx" 
              :type="currTabKey === comp.name?'primary':''"  
              :class="{ active: currTabKey === comp.name }"
              size="large"
              @click="currTabKey = comp.name"
            >
              {{ tabTitles[comp.name] }}
            </el-button>
          </el-button-group>
        </div>

        <component
          :is="tabComps[currTabKey]"
          :data="data"
          :basic-bank-list="basicBankList"
        />
      </template>
      <div v-else class="base-card-info text-center">
        暂无易宝信息
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
import { tabTitles } from './meta';
import { ref, computed, PropType } from 'vue';
import { useRoute } from 'vue-router';
import ElectronicHouseholdInfo from './ElectronicHouseholdInfo.vue';
import YibaoAccountInfo from './YibaoAccountInfo.vue';
import OfflinePaymentInfo from './OfflinePaymentInfo.vue';
import { IMasterBank, IYibaoDetail } from '../../../../types/yibao';

defineOptions({ name: 'RegisterInfo' }); // 空中分账 - 分账产品 - 企业配置

const props = defineProps({
  data: {
    type: Object as PropType<IYibaoDetail>,
    default() {
      return {} as IYibaoDetail;
    },
  },
  basicBankList: {
    type: Array<IMasterBank>,
    default() {
      return [] as IMasterBank[];
    },
  },
});

const route = useRoute();

const loading = ref(false);
const currTabKey = ref(route.query.tabKey as string || 'YibaoAccountInfo');

const emptyData = computed(() => Object.keys(props.data).length === 0);
const source = computed(() => route.query.from);

const tabComps = computed(() => {
  let comps = {} as any;
  const tabCompsYibao = {
    YibaoAccountInfo, // 易宝
    ElectronicHouseholdInfo, // 电子户
    OfflinePaymentInfo, // 线下
  };

  switch (source.value) {
    case 'company':
      comps = tabCompsYibao;
      break;
    case 'agent':
      comps = { YibaoAccountInfo };
      break;
    default:
      comps = tabCompsYibao;
  }

  return comps;
});

</script>

<style lang="scss" scoped>
.cw-tabs > div {
  @apply max-3xl:text-[15px];

  &.active {
    @apply max-3xl:text-[17px];
  }
}
</style>
